<script setup lang="ts">
import { computed } from 'vue';
import {
  mdiBookOpenPageVariantOutline,
  mdiViewGridOutline,
  mdiCheckboxMarkedCircleOutline,
} from '@quasar/extras/mdi-v7';

const props = defineProps<{
  completed: { steps: number; sections: number; courses: number };
  incomplete: { steps: number; sections: number; courses: number };
}>();

const rows = computed(() => [
  {
    key: 'courses',
    acc: 'acc-courses',
    icon: mdiBookOpenPageVariantOutline,
    label: 'COMPLETED_COURSES',
    completed: props.completed.courses,
    incomplete: props.incomplete.courses,
  },
  {
    key: 'sections',
    acc: 'acc-sections',
    icon: mdiViewGridOutline,
    label: 'COMPLETED_SECTIONS',
    completed: props.completed.sections,
    incomplete: props.incomplete.sections,
  },
  {
    key: 'steps',
    acc: 'acc-steps',
    icon: mdiCheckboxMarkedCircleOutline,
    label: 'COMPLETED_STEPS',
    completed: props.completed.steps,
    incomplete: props.incomplete.steps,
  },
]);
</script>
<template>
  <div class="stat-card">
    <div class="stat-card__head">
      <div class="stat-card__title">{{ $t('PROGRESS_OVERVIEW') }}</div>
    </div>
    <div class="stat-rows">
      <div
        v-for="row in rows"
        :key="row.key"
        class="stat-row"
        :class="row.acc"
      >
        <div class="stat-badge stat-badge--sm">
          <q-icon
            :name="row.icon"
            size="18px"
          />
        </div>
        <div class="stat-row__text">
          <div class="stat-label ellipsis">{{ $t(row.label) }}</div>
          <div class="stat-sub">
            {{ row.incomplete }} {{ $t('IN_PROGRESS') }}
          </div>
        </div>
        <div class="stat-row__value">{{ row.completed }}</div>
      </div>
    </div>
  </div>
</template>
